import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { ProductSection } from '../components/sections/ProductSection';
import { BenefitsCarouselSection } from '../components/sections/BenefitsCarouselSection';
import { FeaturesSection } from '../components/sections/FeaturesSection';
import { TestimonialsSection } from '../components/sections/TestimonialsSection';
import { ValueStackSection } from '../components/sections/ValueStackSection';
import { PricingSection } from '../components/sections/PricingSection';
import { GuaranteeSection } from '../components/sections/GuaranteeSection';
import { FAQSection } from '../components/sections/FAQSection';
import { EmpathySection } from '../components/sections/EmpathySection';
import { TestimonialJulianaSection } from '../components/sections/TestimonialJulianaSection';
import { ForWhomSection } from '../components/sections/ForWhomSection';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-stone-900 selection:bg-brand-100 selection:text-brand-900" data-id="element-490">
      <HeroSection data-id="element-491" />
      <EmpathySection data-id="element-492" />
      <TestimonialJulianaSection data-id="element-493" />
      <ProductSection data-id="element-494" />

      <FeaturesSection data-id="element-495" />
      <ForWhomSection data-id="element-496" />
      <TestimonialsSection data-id="element-497" />
      <PricingSection data-id="element-498" />
      <GuaranteeSection data-id="element-499" />
      <FAQSection data-id="element-500" />

      {/* Footer */}
      <footer className="bg-stone-900 text-white py-12 border-t border-stone-800" data-id="element-501">
        <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-502">
          <p className="text-xl mb-4 font-serif font-bold" data-id="element-503">
            O Efeito Boutique™
          </p>
          <p className="text-stone-400 text-sm" data-id="element-504">
            © 2024 Todos os direitos reservados. | Política de Privacidade |
            Termos de Uso
          </p>
        </div>
      </footer>
    </div>;
}